import { render } from "./ReportPassengerFlow.vue?vue&type=template&id=02194cc6"
import script from "./ReportPassengerFlow.vue?vue&type=script&lang=js"
export * from "./ReportPassengerFlow.vue?vue&type=script&lang=js"
script.render = render

export default script